import React, { useEffect, useRef } from 'react';
import { View } from 'react-native-web';
import * as Animatable from 'react-native-animatable';

// Configs
import GLOBAL from '../configs/config_global';
import { setGlobalState, STATE_KEYS } from '../configs/config_state';

export function InScreenModal(props) {
    const { visible, children, onShow = () => {}, onDismiss = () => {}, fullWidth = false, style = {} } = props;

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (visible) {
            setGlobalState(STATE_KEYS.IN_SCREEN_MODAL_SHOWING, true);
            onShow();
        }
        else {
            setGlobalState(STATE_KEYS.IN_SCREEN_MODAL_SHOWING, false);
            onDismiss();
        }
    }, [visible]);

    return(
        visible &&
        <Animatable.View
            animation={'fadeIn'}
            duration={400}
            style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.8)' }}>
            <View style={[{ flex: 1, marginHorizontal: fullWidth ? '2.5%' : '15%', marginVertical: '2.5%', borderWidth: 2, borderRadius: 16, borderColor: GLOBAL.COLOR.DIVIDER, overflow: 'hidden', backgroundColor: 'white' }, style]}>
                {children}
            </View>
        </Animatable.View>
    );
}
